/* eslint-disable */
import { reportError } from 'config/sentry';

export const handleError = (error, errorInfo) => {
  console.error(error, errorInfo);
  reportError(error, errorInfo);
};
